import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGallery } from '../hooks/useGallery';
import ProductCard from '../components/ProductCard';
import { mockGalleryItems } from '../data/mockGallery';
import '../styles/Gallery.css';

const Gallery: React.FC = () => {
  const { t } = useTranslation();
  const { items, addItem } = useGallery();
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // Initialize gallery with mock data if empty
    if (!isInitialized && items.length === 0) {
      mockGalleryItems.forEach(item => addItem(item));
      setIsInitialized(true);
    }
  }, [items.length, addItem, isInitialized]);

  const categories = [
    { id: 'all', label: t('gallery.filter.all') },
    { id: 'rings', label: t('gallery.filter.rings') },
    { id: 'necklaces', label: t('gallery.filter.necklaces') },
    { id: 'earrings', label: t('gallery.filter.earrings') },
    { id: 'molds', label: t('gallery.filter.mold') }
  ];

  const filteredItems = selectedCategory === 'all'
    ? items
    : items.filter(item => item.category === selectedCategory);

  return (
    <div className="gallery-page">
      <div className="gallery-section">
        <h1 className="gallery-title">{t('gallery.title')}</h1>
        <p className="gallery-description">{t('gallery.description')}</p>

        {/* Category Filter */}
        <div className="gallery-filter">
          {categories.map(category => (
            <button
              key={category.id}
              onClick={() => setSelectedCategory(category.id)}
              className={`gallery-filter-btn${selectedCategory === category.id ? ' gallery-filter-btn-active' : ''}`}
            >
              {category.label}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="gallery-grid">
          {filteredItems.length > 0 ? (
            filteredItems.map(item => (
              <ProductCard key={item.id} item={item} />
            ))
          ) : (
            <p className="gallery-no-results">{t('gallery.noResults')}</p>
          )}
        </div>

        {/* Contact CTA */}
        <div className="gallery-cta">
          <h2 className="gallery-cta-title">{t('home.gallery.items.weddingRing.title')}</h2>
          <p className="gallery-cta-desc">{t('home.gallery.items.weddingRing.description')}</p>
          <button className="gallery-cta-btn">
            {t('home.gallery.viewAll')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Gallery; 